/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kind_Slimy_Tern_HuntInputs */

const fr_kind_slimy_tern_hunt = /** @type {(inputs: Kind_Slimy_Tern_HuntInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réserver`)
};

/**

* @param {Kind_Slimy_Tern_HuntInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const kind_slimy_tern_hunt = /** @type {((inputs?: Kind_Slimy_Tern_HuntInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kind_Slimy_Tern_HuntInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_kind_slimy_tern_hunt(inputs)
});